<template>
  <va-card :title="$t('menu.setup_initial')">
    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      :fields="fields"
      :data="data"
      api-mode
      v-show="!loading"
      @page-selected="readItems"
    >

    <template slot="actions" slot-scope="props">
      <va-button v-if="ability.can('update', 'SetupMenu')"
        small
        inline
        color="green"
        icon="fa fa-edit"
        class="ma-0"
        :to="{ name: 'form-general-setup', params: { id: props.rowData.id } }"
      >
        {{ $t('menu.edit') }}
      </va-button>
    </template>
    </va-data-table>
  </va-card>
</template>

<script>

import GeneralSetupAPI from '@/services/GeneralSetupAPI'
import * as spinners from 'epic-spinners'

import { mapState } from "vuex";
import { Ability } from '@casl/ability'
export const ability = new Ability()

export default {
  components: {
    ...spinners,
  },
  data () {
    return {
      data: [],
      term: null,
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      general_setups: {
        id: '',
        cdn: '',
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      ability: [],
    }
  },

  channels: {
    NeedRefreshLocalities: {
      received(data) {
        this.readItems()
      },
    }
  },

  beforeMount(){
    this.ability = ability.update(this.rules)
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshLocalities', company: this.currentUser.company })
    this.readItems()
  },

  computed: {
    ...mapState(['rules', 'currentUser']),

    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.general_setups.id'),
        width: '5%',
      },
      {
        name: 'tenant_name',
        title: this.$t('tables.general_setups.tenant_name'),
      },
      {
        name: 'cdn',
        title: this.$t('tables.general_setups.cdn'),
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    spload () {
      // return spinners.SpinnerName
      return spinners.ScalingSquaresSpinner
    }
  },
  created () {
    this.readItems()
  },
  methods: {
    async readItems () {

      await GeneralSetupAPI.getGeneralSetups().then(response => {
        this.data = response.data.general_setups
        this.loading = false
      })
    },
  },
}
</script>

  <style lang="scss">
  </style>
